import { useEffect, useRef, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { AldapaMark } from '../brand/AldapaMark'
import { mainNavigation } from '../../data/navigation'
import './SiteHeader.css'

export function SiteHeader() {
  const [open, setOpen] = useState(false)
  const [query, setQuery] = useState('')
  const search = useRef<HTMLDialogElement>(null)
  const searchButton = useRef<HTMLButtonElement>(null)
  const menuButton = useRef<HTMLButtonElement>(null)
  useEffect(() => {
    document.body.classList.toggle('menu-open', open)
    return () => document.body.classList.remove('menu-open')
  }, [open])
  const matches = mainNavigation.filter(item => item.label.toLowerCase().includes(query.trim().toLowerCase()))
  return <>
    <header className="site-header" onKeyDown={event => {
      if (event.key === 'Escape' && open) { setOpen(false); menuButton.current?.focus() }
    }}>
      <div className="site-header__inner">
        <Link className="brand-mark" to="/" aria-label="Aldapa Systems home" onClick={() => setOpen(false)}><AldapaMark /></Link>
        <nav id="mobile-navigation" className={`site-nav ${open ? 'is-open' : ''}`} aria-label="Main navigation">
          <div className="site-nav__links">
            {mainNavigation.map(item => <NavLink key={item.path} to={item.path} end={item.path === '/'} onClick={() => setOpen(false)}>{item.label}</NavLink>)}
          </div>
          <div className="account-nav">
            <button className="site-search-button" type="button" ref={searchButton} aria-label="Search website" onClick={() => { setQuery(''); search.current?.showModal() }}>
              <svg viewBox="0 0 24 24" width="23" height="23" fill="none" stroke="currentColor" strokeWidth="1.7" aria-hidden="true"><circle cx="10.5" cy="10.5" r="7.2" /><path d="m16 16 5 5" /></svg>
            </button>
            <Link className="site-signin" to="/signin" onClick={() => setOpen(false)}>Sign in</Link>
            <Link className="site-create-account" to="/account/create" onClick={() => setOpen(false)}>Create account <span aria-hidden="true">→</span></Link>
          </div>
        </nav>
        <button ref={menuButton} className="menu-toggle" type="button" aria-expanded={open} aria-controls="mobile-navigation" aria-label={open ? 'Close menu' : 'Open menu'} onClick={() => setOpen(value => !value)}>
          <span>{open ? 'Close' : 'Menu'}</span><i aria-hidden="true" />
        </button>
      </div>
    </header>
    <dialog className="site-search" ref={search} aria-labelledby="site-search-title" onClose={() => searchButton.current?.focus()}>
      <div className="site-search__heading"><h2 id="site-search-title">Search Aldapa Systems</h2><button type="button" aria-label="Close search" onClick={() => search.current?.close()}>×</button></div>
      <label className="visually-hidden" htmlFor="site-search-input">Find a page</label>
      <input id="site-search-input" type="search" placeholder="Find a page…" value={query} onChange={event => setQuery(event.target.value)} />
      <div className="site-search__results" aria-live="polite">{matches.length ? matches.map(item => <Link key={item.path} to={item.path} onClick={() => { search.current?.close(); setOpen(false) }}>{item.label}<span aria-hidden="true">↗</span></Link>) : <p>No matching pages.</p>}</div>
    </dialog>
  </>
}
